<template>
  <div>
    <div class="invoice-flow__logo-wrapper">
      <div class="method-options-card-header__icon" :style="logoStyles" />

      <div>{{ $t(method.name) }}</div>
    </div>

    <div class="message" v-html="message" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import sanitizeHtml from 'sanitize-html';

export default {
  computed: {
    ...mapState(['flowData']),

    /*
     * @getter data
     * @returns {
     *     message: { [key: string(locale)]: string (html string | "[]") },
     *     method: string,
     *     logo: string,
     *  } | {}
     * */
    data() {
      return this.flowData.payload;
    },

    method() {
      return {
        logo: this.data.logo,
        name: this.data.method,
      };
    },

    message() {
      if (this.data.message === '[]') {
        return '';
      }

      const locale = this.$i18n.locale || 'en';
      const message = this.data.message[locale]
        ? this.data.message[locale]
        : this.data.message['en'];

      return sanitizeHtml(message || '');
    },

    logoStyles() {
      return {
        'min-height': '10em',
        width: '10em',
        'background-image': `url(${this.method.logo})`,
        'background-repeat': 'no-repeat',
        'background-position': 'center',
        'background-size': 'contain',
        'margin-bottom': '20px',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-flow__logo-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 2em;
  align-items: center;
}

.message {
  ul {
    text-align: left;
  }
}
</style>
